const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate allEmployeesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const excluding = await evaluateSource(source.excluding, content, parentContentPath, transientContext, nativeFunctions);
  const {
    filterText
  } = transientContext;
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'User',
    properties: ['id', 'firstName', 'lastName', 'employeeNumber'],
    equals: {
      active: 1
    },
    equalsNoneOf: {
      id: excluding
    },
    contains: {
      lastName: filterText
    }
  };
  const users = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  const result = {};
  users.forEach(user => {
    result[user.id] = {
      title: `${user.firstName} ${user.lastName}`,
      _created: `${user.lastName} ${user.firstName}`,
      employeeNumber: user.employeeNumber
    };
  });
  return result;
};
module.exports = {
  evaluate
};